import { useDispatch, useSelector } from 'react-redux';

import {
  getCommentsCount,
  ICommentsStorage,
  setComment,
} from '../store/reducers/comments/comments-reducer';

interface useCommentsCountsProps {
  type: string;
  uuid: string;
}

export default function useCommentsCounts({ type, uuid }: useCommentsCountsProps) {
  const dispatch = useDispatch();

  const commentsCount = useSelector((state: ICommentsStorage) =>
    getCommentsCount(state, type, uuid)
  );

  const handleAddComment = () => {
    dispatch(setComment({ type, uuid, count: commentsCount + 1 }));
  };

  const handleRemoveComment = () => {
    dispatch(setComment({ type, uuid, count: commentsCount - 1 }));
  };

  const handleSetCommentsCount = (count: number) => {
    dispatch(setComment({ type, uuid, count }));
  };

  return { commentsCount, handleAddComment, handleRemoveComment, handleSetCommentsCount };
}
